import { useEffect, useState } from "react";

import "../../assets/css/product.scss";
import Header from "../../components/header";
import Footer from "../../components/footer";

import ProductAuthModal from "../../components/modal/product_auth_modal";
import { SessionStorageUtil } from "../../utils/sessionStorageUtil";
import { useNavigate } from "react-router-dom";

function DonationStep1Page() {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (SessionStorageUtil.getItem("authToken")) {
      navigate("/donation_step2", { replace: true });
    }
  }, [navigate]);

  if (SessionStorageUtil.getItem("authToken")) {
    return null;
  }

  return (
    <div className="product-list-container">
      <Header />
      <ul className="section1">
        <li>기부내역 조회하기</li>
        <li>
          정기 결제완료 시 Newspaper In Education ‘NIE’ 후원 캠페인에
          참여합니다.
          <br />
          사랑을 나누는 종이비행기 어린이동아로 교육기부를 실천해보세요.
          <br />
          감사합니다.
          <br />
          기부 문의: 동아일보 교육법인 (주)동아이지에듀
          <br />
          Tel: 02-362-5109
        </li>
        <li>
          <button onClick={() => setIsModalOpen(true)}>조회하기</button>
        </li>
      </ul>
      <Footer />

      <ProductAuthModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={() => {
          setIsModalOpen(false);
          navigate("/donation_step2", { replace: true });
        }}
      />
    </div>
  );
}

export default DonationStep1Page;
